import Skeleton from '@/common/helios/Skeleton';
import { useDeviceType } from '~/context/common/DeviceContext';
import { useIsNewVehicle } from '~/context/vdp/VehicleContext';
import { usePriceDrop } from '~/hooks/vdp';
import useIsPriceLoading from '~/hooks/vdp/selectors/useIsPriceLoading';
import NewVehiclePrice from './NewVehiclePrice';
import PriceDrop from './PriceDrop';
import PriceWithDiscount from './PriceWithDiscount';

export default function Price() {
  const { isDesktop } = useDeviceType();
  const isLoading = useIsPriceLoading();
  const isNewVehicle = useIsNewVehicle();
  const { showPriceDrop } = usePriceDrop();

  if (isLoading) {
    return (
      <Skeleton height={isDesktop ? 32 : 26} width={isDesktop ? 115 : 100} />
    );
  }

  if (isNewVehicle) {
    return <NewVehiclePrice />;
  }

  if (showPriceDrop) {
    return <PriceDrop />;
  }

  return <PriceWithDiscount />;
}
